<template>
    <SettingsLayout>
        <SettingsSubHeader v-if="hasAnyIntegration">
            <template #title> {{ $t("integrations.title") }} </template>
            <template #description>
                {{ $t("integrations.description") }}</template
            >

            <template #actions>
                <AddIntegrationModal>
                    <AddButton>{{
                        $t("integrations.add_integration")
                    }}</AddButton>
                </AddIntegrationModal>
            </template>
        </SettingsSubHeader>

        <!-- <nav class="mx-auto mt-6 flex max-w-7xl px-8" aria-label="Tabs">
            <a
                v-for="tab in tabs"
                :key="tab.name"
                :href="tab.href"
                :class="[
                    'inline-flex items-center px-3 py-2 text-center text-sm font-medium',
                    tab.current
                        ? ' rounded-lg bg-iron-200 text-center text-iron-700 '
                        : 'text-iron-500 hover:border-iron-300 hover:text-iron-700  ',
                ]"
            >
                {{ tab.name }}
                <span
                    v-if="tab.count !== undefined"
                    class="ml-2 rounded px-[5px] text-xs leading-[18px]"
                    :class="[
                        tab.current
                            ? 'bg-iron-700 text-white'
                            : 'bg-iron-200 text-iron-700',
                    ]"
                    >{{ tab.count }}</span
                >
            </a>
        </nav> -->

        <div v-if="!hasAnyIntegration" class="">
            <EmptyStateWithIcon
                class="mt-[52px]"
                :title="$t('integrations.empty_state.title')"
                :description="$t('integrations.empty_state.description')"
            >
                <template #icon>
                    <svg
                        width="76"
                        height="76"
                        viewBox="0 0 76 76"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_2536_7655)">
                            <path
                                d="M54.1224 23.908C54.1702 24.7254 54.6062 25.4705 55.2919 25.9159L59.9669 28.9518C61.3682 29.8618 62.271 31.2556 62.5935 32.7727C62.9159 34.2898 62.66 35.9273 61.7481 37.3316L58.6289 42.1348C58.4192 42.4573 58.1368 42.7263 57.8045 42.9201C57.4722 43.1139 57.099 43.2272 56.7151 43.2509C55.5228 43.3244 54.4922 42.4898 53.8514 41.4824C53.2878 40.5916 52.5092 39.8569 51.5873 39.3458C50.6655 38.8346 49.6299 38.5635 48.5758 38.5573C47.5217 38.5511 46.483 38.81 45.5552 39.3103C44.6274 39.8105 43.8402 40.536 43.2661 41.42C42.692 42.3041 42.3494 43.3183 42.2698 44.3693C42.1902 45.4204 42.3761 46.4747 42.8105 47.4351C43.2449 48.3955 43.9138 49.2313 44.7557 49.8656C45.5976 50.4998 46.5855 50.9123 47.6285 51.0649C48.8119 51.2399 49.9905 51.8401 50.4088 52.9616C50.5436 53.322 50.592 53.709 50.5501 54.0914C50.5082 54.4739 50.3772 54.8412 50.1676 55.1639L47.0504 59.9641C46.6178 60.6327 46.0574 61.2091 45.4014 61.6604C44.7453 62.1116 44.0065 62.4288 43.2275 62.5936C42.4494 62.7601 41.6461 62.7711 40.8637 62.626C40.0813 62.4809 39.3354 62.1826 38.6687 61.7483L33.9937 58.7123C33.6557 58.4924 33.2708 58.3548 32.87 58.3105C32.4691 58.2663 32.0635 58.3167 31.6857 58.4576C30.5122 58.8972 29.8837 60.1359 29.6836 61.3709C29.515 62.4019 29.092 63.3747 28.4529 64.2012C27.8138 65.0276 26.9788 65.6818 26.0233 66.1043C25.0678 66.5269 24.022 66.7046 22.9806 66.6213C21.9392 66.538 20.9349 66.1964 20.0587 65.6274C19.1825 65.0584 18.462 64.2799 17.9623 63.3624C17.4627 62.4449 17.1996 61.4172 17.197 60.3725C17.1944 59.3277 17.4523 58.2988 17.9474 57.3788C18.4425 56.4588 19.1591 55.6767 20.0325 55.1034C21.0793 54.4183 21.9553 53.3403 21.8771 52.0899C21.8525 51.6876 21.734 51.2966 21.531 50.9483C21.328 50.6 21.0461 50.3042 20.7081 50.0846L16.0331 47.0486C15.3652 46.6162 14.7893 46.056 14.3385 45.4003C13.8878 44.7446 13.5711 44.0062 13.4066 43.2277C13.0841 41.7106 13.342 40.0701 14.252 38.6688L17.2066 34.1191C17.6713 33.4035 18.4507 32.9474 19.303 32.8948C20.6096 32.8149 21.7354 33.7347 22.4692 34.8174C23.0516 35.6747 23.8369 36.3747 24.7553 36.8549C25.6737 37.3352 26.6966 37.5809 27.7329 37.5702C28.7692 37.5595 29.7868 37.2926 30.695 36.7933C31.6032 36.2941 32.3738 35.578 32.9383 34.7088C33.5027 33.8397 33.8435 32.8444 33.9302 31.8116C34.0168 30.7789 33.8467 29.7407 33.435 28.7896C33.0234 27.8385 32.3828 27.004 31.5705 26.3604C30.7582 25.7168 29.7994 25.284 28.7793 25.1007C27.4917 24.8707 26.1936 24.2163 25.7351 22.9902C25.4365 22.1902 25.5342 21.2957 26.0009 20.5771L28.9536 16.0303C29.386 15.3631 29.946 14.7879 30.6014 14.3377C31.2568 13.8875 31.9946 13.5711 32.7725 13.4068C34.2896 13.0843 35.9301 13.3421 37.3314 14.2521L42.0064 17.2881C42.6921 17.7334 43.5502 17.8286 44.3144 17.5428C45.4879 17.1032 46.1164 15.8645 46.3165 14.6296C46.4851 13.5985 46.908 12.6257 47.5471 11.7993C48.1862 10.9728 49.0213 10.3187 49.9768 9.89611C50.9323 9.47355 51.978 9.29587 53.0195 9.37914C54.0609 9.46241 55.0651 9.804 55.9413 10.373C56.8175 10.942 57.5381 11.7205 58.0377 12.638C58.5374 13.5556 58.8004 14.5832 58.803 15.6279C58.8056 16.6727 58.5477 17.7016 58.0526 18.6216C57.5576 19.5416 56.8409 20.3237 55.9676 20.8971C54.9207 21.5822 54.0443 22.6577 54.1224 23.908Z"
                                stroke="url(#paint0_linear_2536_7655)"
                                stroke-width="4"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                        <defs>
                            <linearGradient
                                id="paint0_linear_2536_7655"
                                x1="14.5664"
                                y1="22.4187"
                                x2="60.7025"
                                y2="54.9243"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FF8D47" />
                                <stop offset="0.147634" stop-color="#FF7447" />
                                <stop offset="0.454086" stop-color="#FF4247" />
                                <stop offset="0.636926" stop-color="#E92A5B" />
                                <stop offset="0.740367" stop-color="#DD1C67" />
                                <stop offset="0.842991" stop-color="#D31071" />
                                <stop offset="1" stop-color="#CF0283" />
                            </linearGradient>
                            <clipPath id="clip0_2536_7655">
                                <rect
                                    width="64"
                                    height="64"
                                    fill="white"
                                    transform="translate(0.0461426 13.3525) rotate(-12)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                </template>
            </EmptyStateWithIcon>

            <div class="mt-8 flex justify-center">
                <AddIntegrationModal>
                    <AddButton data-cy="create-new-day-off">
                        {{ $t("integrations.add_integration") }}</AddButton
                    >
                </AddIntegrationModal>
            </div>
        </div>

        <div
            class="max-w-7xl gap-6 py-6 sm:px-6 md:grid-cols-2 lg:px-6 mx-auto grid"
        >
            <GoogleIntegrationModal
                v-for="integration of googleIntegrations"
                :key="integration.id"
                :integration="integration"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="google-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <GoogleCalendarLogo />
                    </template>

                    <template #name>
                        {{ $t("integrations.google.title") }}
                    </template>

                    <template v-if="integration?.data.email" #identifier>
                        {{ integration.data.email }}
                    </template>

                    <template #description>
                        {{ $t("integrations.google.description") }}
                    </template>
                </IntegrationCard>
            </GoogleIntegrationModal>

            <AppleCalendarIntegrationModal
                v-for="integration of iCloudCalendarIntegrations"
                :key="integration.id"
                :integration="integration"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    gradient-class="icloud-gradient"
                    selected
                    has-sub
                    :has-error="hasIntegrationIssue(integration)"
                >
                    <template #logo>
                        <div
                            class="rounded-lg bg-white shadow-sm flex h-[56px] w-[56px] items-center justify-center"
                        >
                            <img
                                height="18"
                                width="32"
                                src="https://d39xau2r7ekvda.cloudfront.net/application/assets/img/icloud-calendar.png"
                            />
                        </div>
                    </template>

                    <template #name>
                        {{ $t("integrations.icloud_calendar.title") }}
                    </template>

                    <template v-if="integration?.data.iCloudEmail" #identifier>
                        {{ integration.data.iCloudEmail }}
                    </template>

                    <template #description>
                        {{ $t("integrations.icloud_calendar.description") }}
                    </template>
                </IntegrationCard>
            </AppleCalendarIntegrationModal>

            <MicrosoftIntegrationModal
                v-for="integration of microsoftIntegrations"
                :key="integration.id"
                :integration="integration"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="microsoft-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <MicrosoftLogo />
                    </template>

                    <template #name>
                        {{ $t("integrations.microsoft.title") }}
                    </template>

                    <template v-if="integration?.data.email" #identifier>
                        {{ integration.data.email }}
                    </template>

                    <template #description>
                        {{ $t("integrations.microsoft.description") }}
                    </template>
                </IntegrationCard>
            </MicrosoftIntegrationModal>

            <MicrosoftTeamsIntegrationModal
                v-for="integration of microsoftTeamsIntegrations"
                :key="integration.id"
                :integration="integration"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="microsoft-teams-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <MicrosoftTeamsLogo />
                    </template>

                    <template #name>
                        {{ $t("integrations.microsoft_teams.title") }}
                    </template>

                    <template v-if="integration?.data.email" #identifier>
                        {{ integration.data.email }}
                    </template>

                    <template #description>
                        {{ $t("integrations.microsoft_teams.description") }}
                    </template>
                </IntegrationCard>
            </MicrosoftTeamsIntegrationModal>

            <EcomailIntegrationModal
                v-for="ecmIntegration of ecomailIntegrations"
                :key="ecmIntegration.id"
                :integration="ecmIntegration"
                removable
                @remove-integration="removeIntegration(ecmIntegration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="ecmIntegration.id"
                    :has-error="hasIntegrationIssue(ecmIntegration)"
                    gradient-class="ecm-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <EcomailLogo />
                    </template>

                    <template #name>
                        {{ $t("integrations.ecomail.title") }}
                        <br />
                        <span class="font-normal tracking-[-0.02em]">
                            {{ ecmIntegration.name }}
                        </span>
                    </template>

                    <template #description>
                        {{ $t("integrations.ecomail.description") }}
                    </template>
                </IntegrationCard>
            </EcomailIntegrationModal>

            <CloseIntegrationModal
                v-for="integration of closeIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="close-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <CloseLogo />
                    </template>

                    <template #name>
                        {{ $t("integrations.close.title") }}
                        <br />
                        <span class="font-normal tracking-[-0.02em]">
                            {{ integration.name }}
                        </span>
                    </template>

                    <template #description>
                        {{ $t("integrations.close.description") }}
                    </template>
                </IntegrationCard>
            </CloseIntegrationModal>

            <SlackIntegrationModal
                v-for="integration of slackIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="slack-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <SlackLogo />
                    </template>

                    <template #name>
                        {{ $t("integrations.slack.title") }}
                    </template>

                    <template #description>
                        {{ $t("integrations.slack.description") }}
                    </template>
                </IntegrationCard>
            </SlackIntegrationModal>

            <RaynetIntegrationModal
                v-for="integration of raynetIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="raynet-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <div
                            class="rounded-lg bg-white shadow-sm flex h-[56px] w-[56px] items-center justify-center"
                        >
                            <img
                                height="18"
                                width="32"
                                src="https://d39xau2r7ekvda.cloudfront.net/application/assets/img/Raynet.png"
                            />
                        </div>
                    </template>

                    <template #name>
                        {{ $t("integrations.raynet.title") }}
                        <br />
                        <span class="font-normal tracking-[-0.02em]">
                            {{ integration.name }}
                        </span>
                    </template>

                    <template #description>
                        {{ $t("integrations.raynet.description") }}
                    </template>
                </IntegrationCard>
            </RaynetIntegrationModal>

            <FreeloIntegrationModal
                v-for="integration of freeloIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="freelo-gradient"
                    has-sub
                    selected
                >
                    <template #logo>
                        <FreeloLogo />
                    </template>

                    <template #name>
                        Freelo
                        <br />
                        <span class="font-normal tracking-[-0.02em]">
                            {{ integration.name }}
                        </span>
                    </template>

                    <template #description>
                        {{ $t("integrations.freelo.description") }}
                    </template>
                </IntegrationCard>
            </FreeloIntegrationModal>

            <StripeIntegrationModal
                v-for="integration of stripeIntegrations"
                :key="integration.id"
                :integration="integration"
                :removable="true"
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="stripe-gradient"
                    has-sub
                    selected
                >
                    <template #logo>
                        <StripeLogo class="-ml-1 w-16" />
                    </template>

                    <template #name>
                        Stripe
                        <br />
                        <span
                            v-if="integration.name"
                            class="font-normal tracking-[-0.02em]"
                        >
                            {{ integration.name }}
                        </span>
                    </template>

                    <template #description>
                        {{ $t("integrations.stripe.description") }}
                    </template>
                </IntegrationCard>
            </StripeIntegrationModal>

            <ZoomIntegrationModal
                v-for="integration of zoomIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    gradient-class="stripe-gradient"
                    has-sub
                    selected
                    :has-error="hasIntegrationIssue(integration)"
                >
                    <template #logo>
                        <ZoomLogo class="-ml-1 w-16" />
                    </template>

                    <template #name>
                        Zoom
                        <br />
                        <span
                            v-if="integration.name"
                            class="font-normal tracking-[-0.02em]"
                        >
                            {{ integration.name }}
                        </span>
                    </template>

                    <template #description>
                        {{ $t("integrations.zoom.description") }}
                    </template>
                </IntegrationCard>
            </ZoomIntegrationModal>

            <!-- Webhooks -->
            <WebhookIntegrationModal
                v-for="integration of webhookIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="zaptime-gradient"
                    selected
                    has-sub
                >
                    <template #logo>
                        <Webhook :size="56" />
                    </template>

                    <template #name>
                        {{ $t("integrations.webhook.title") }}
                        <br />
                        <span class="font-normal tracking-[-0.02em]">
                            {{ integration.name }}
                        </span>
                    </template>

                    <template #identifier>
                        {{ integration.data?.url }}
                    </template>

                    <template #description>
                        {{ $t("integrations.webhook.description") }}
                    </template>
                </IntegrationCard>
            </WebhookIntegrationModal>

            <PipedriveIntegrationModal
                v-for="integration of pipedriveIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="pipedrive-gradient"
                    has-sub
                    selected
                >
                    <template #logo>
                        <PipedriveLogo />
                    </template>

                    <template #name> Pipedrive </template>

                    <template #description>
                        {{ $t("integrations.pipedrive.description") }}
                    </template>
                </IntegrationCard>
            </PipedriveIntegrationModal>

            <HubspotIntegrationModal
                v-for="integration of hubspotIntegrations"
                :key="integration.id"
                :integration="integration"
                removable
                @remove-integration="removeIntegration(integration)"
            >
                <IntegrationCard
                    ref="integrationCard"
                    :data-integration-id="integration.id"
                    :has-error="hasIntegrationIssue(integration)"
                    gradient-class="hubspot-gradient"
                    has-sub
                    selected
                >
                    <template #logo>
                        <HubspotLogo />
                    </template>

                    <template #name> HubSpot </template>

                    <template #description>
                        {{ $t("integrations.hubspot.description") }}
                    </template>
                </IntegrationCard>
            </HubspotIntegrationModal>

            <!-- MCP (AI assistants) -->
            <McpDetailModal
                v-model:open="mcpDetailDialogOpen"
                :show-trigger="showMcpCard"
            >
                <template #trigger>
                    <IntegrationCard
                        gradient-class="mcp-gradient"
                        class="cursor-pointer"
                        selected
                        has-sub
                    >
                        <template #logo>
                            <Bot :size="56" />
                        </template>

                        <template #name>
                            {{ $t("integrations.mcp.title") }}
                        </template>

                        <template #identifier>
                            {{
                                $t(
                                    "integrations.mcp.connections_count",
                                    mcp.connections.length,
                                )
                            }}
                        </template>

                        <template #description>
                            {{ $t("integrations.mcp.description") }}
                        </template>
                    </IntegrationCard>
                </template>
            </McpDetailModal>
        </div>
    </SettingsLayout>
</template>

<script lang="ts" setup>
import EcomailIntegrationModal from "./components/AddOrUpdateModals/EcomailIntegrationModal.vue";
import CloseIntegrationModal from "./components/AddOrUpdateModals/CloseIntegrationModal.vue";
import AppleCalendarIntegrationModal from "./components/AddOrUpdateModals/ICloudCalendarIntegrationModal.vue";
import MicrosoftIntegrationModal from "./components/AddOrUpdateModals/MicrosoftIntegrationModal.vue";
import MicrosoftLogo from "./components/logos/Microsoft.svg";
import MicrosoftTeamsIntegrationModal from "./components/AddOrUpdateModals/MicrosoftTeamsIntegrationModal.vue";
import MicrosoftTeamsLogo from "./components/logos/MicrosoftTeams.svg";
import { computed, onMounted, ref, useTemplateRef } from "vue";
import SlackIntegrationModal from "./components/AddOrUpdateModals/SlackIntegrationModal.vue";
import EcomailLogo from "./components/logos/Ecomail.svg";
import SlackLogo from "./components/logos/Slack.svg";
import CloseLogo from "./components/logos/Close.svg";
import ZoomLogo from "./components/logos/Zoom.svg";
import PipedriveLogo from "./components/logos/Pipedrive.svg";
import HubspotLogo from "./components/logos/Hubspot.svg";
import RaynetLogo from "./components/logos/Raynet.svg";
import GoogleCalendarLogo from "./components/logos/GoogleCalendar.svg";
import StripeLogo from "./components/logos/Stripe.svg";
import FreeloLogo from "./components/logos/Freelo.svg";
import route from "ziggy-js";
import RaynetIntegrationModal from "./components/AddOrUpdateModals/RaynetIntegrationModal.vue";
import CalendlyMigrationModal from "@/Pages/Zaptime/App/Integrations/components/AddOrUpdateModals/CalendlyMigrationModal.vue";
import IntegrationCard from "./components/IntegrationCard.vue";
import FreeloIntegrationModal from "@/Pages/Zaptime/App/Integrations/components/AddOrUpdateModals/FreeloIntegrationModal.vue";
import GoogleIntegrationModal from "./components/AddOrUpdateModals/GoogleIntegrationModal.vue";
import ZoomIntegrationModal from "./components/AddOrUpdateModals/ZoomIntegrationModal.vue";
import PipedriveIntegrationModal from "./components/AddOrUpdateModals/PipedriveIntegrationModal.vue";
import { router } from "@inertiajs/vue3";
import useConfirm from "../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import AddIntegrationModal from "./components/AddIntegrationModal.vue";
import AddButton from "../Atomic/AddButton.vue";
import StripeIntegrationModal from "./components/AddOrUpdateModals/Stripe/StripeIntegrationModal.vue";
import { useUrlSearchParams } from "@vueuse/core";
import SettingsLayout from "@/Layouts/SettingsLayout.vue";
import SettingsSubHeader from "@/Layouts/components/SettingsSubHeader.vue";
import { Button } from "@/components/ui/button";
import { Bot, Plus, Webhook } from "lucide-vue-next";
import { EmptyStateWithIcon } from "@/components/empty-state-with-icon";
import HubspotIntegrationModal from "./components/AddOrUpdateModals/HubspotIntegrationModal.vue";
import WebhookIntegrationModal from "./components/AddOrUpdateModals/WebhookIntegrationModal.vue";
import McpDetailModal from "./components/DetailModals/McpDetailModal.vue";
import { hasIntegrationIssue } from "./utils/hasIntegrationIssue";
import { shouldOpenIntegrationModal } from "./utils/shouldOpenIntegrationModal";
import type { McpIntegration } from "./types";

const props = defineProps<{
    user: any;
    integrations: any[];
    mcp: McpIntegration;
}>();

const showMcpCard = computed(() => {
    return props.mcp.connections.length > 0;
});

const hasAnyIntegration = computed(() => {
    return props.integrations.length !== 0 || showMcpCard.value;
});

const { show } = useConfirm();
const { t } = useI18n();
const params = useUrlSearchParams();
const mcpDetailDialogOpen = ref(false);

const integrationCardRefs = useTemplateRef<HTMLElement[]>("integrationCard");

function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

async function removeIntegration(integration: any) {
    const ok = await show({
        header:
            t("integrations.delete.header") +
                ": " +
                capitalizeFirstLetter(integration.type.toLowerCase()) +
                " " +
                integration?.name || "",
        message: t("integrations.delete.message"),
        confirm: t("integrations.delete.confirm"),
        cancel: t("integrations.delete.cancel"),
    });

    if (ok) {
        router.delete(`/integrations/${integration.id}`);
    }
}

const googleIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "GOOGLE");
});

const iCloudCalendarIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "ICLOUD_CALENDAR");
});

const microsoftIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "MICROSOFT");
});

const microsoftTeamsIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "MICROSOFT_TEAMS");
});

const slackIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "SLACK");
});

const ecomailIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "ECOMAIL");
});

const closeIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "CLOSE");
});

const freeloIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "FREELO");
});

const raynetIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "RAYNET");
});

const stripeIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "STRIPE");
});

const zoomIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "ZOOM");
});

const pipedriveIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "PIPEDRIVE");
});

const hubspotIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "HUBSPOT");
});

const webhookIntegrations = computed(() => {
    return props.integrations.filter((i) => i.type === "WEBHOOK");
});

const tabs = ref([
    {
        name: "Všechny",
        current: true,
        // count: 2,
        // href: route("app.dashboard.upcoming"),
        // current:
        //     route().current("app.dashboard") ||
        //     route().current("app.dashboard.upcoming"),
        // count: props.upcomingReservationsCount,
    },
    {
        name: "Kalendáře",
        current: false,
        // count: 2,
        // href: route("app.dashboard.upcoming"),
        // current:
        //     route().current("app.dashboard") ||
        //     route().current("app.dashboard.upcoming"),
        // count: props.upcomingReservationsCount,
    },
    // {
    //     name: t("bookings.pending"),
    //     href: "#",
    //     current: false,
    // },
    {
        name: "Správa hovorů",
        // href: route("app.dashboard.past"),
        // current: route().current("app.dashboard.past"),
        // count: props.pastReservationsCount,
    },
    {
        name: "CRM",
        // href: route("app.dashboard.cancelled"),
        // current: route().current("app.dashboard.cancelled"),
        // count: props.cancelledReservationsCount,
    },
    {
        name: "Analytika",
        // href: route("app.dashboard.cancelled"),
        // current: route().current("app.dashboard.cancelled"),
        // count: props.cancelledReservationsCount,
    },
    {
        name: "E-mailing",
        // href: route("app.dashboard.cancelled"),
        // current: route().current("app.dashboard.cancelled"),
        // count: props.cancelledReservationsCount,
    },
    {
        name: "Platby",
        // href: route("app.dashboard.cancelled"),
        // current: route().current("app.dashboard.cancelled"),
        // count: props.cancelledReservationsCount,
    },
    {
        name: "Automatizace",
        // href: route("app.dashboard.cancelled"),
        // current: route().current("app.dashboard.cancelled"),
        // count: props.cancelledReservationsCount,
    },
]);

onMounted(() => {
    mcpDetailDialogOpen.value = shouldOpenIntegrationModal(params, "mcp");

    if (params["integrationId"]) {
        const integrationId = params["integrationId"];
        const card = integrationCardRefs.value?.find(
            (el) => el?.dataset?.integrationId === integrationId,
        );

        if (card) {
            (card as HTMLElement).click();
        }
    }
});
</script>
